import { render, staticRenderFns } from "./ChatBotNew.vue?vue&type=template&id=34680fd0"
import script from "./ChatBotNew.vue?vue&type=script&lang=js"
export * from "./ChatBotNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports